<template>
  <div class="iformation" style="padding-top: 20px">
    <div class="infor_box">
      <div class="infor_inner box">
        <div class="infor_params">
          <div class="title">
            <img src="./img/icon_gear_default.png" />
            <span>排放源名称</span>
          </div>
          <div class="infor_params_box">
            <p>
              <label>{{ inventoryName }}</label>
            </p>
          </div>
        </div>
        <!--div class="infor_params">
          <div class="title">
            <img src="./img/icon_gear_default.png" />
            <span>基本参数</span>
          </div>
          <div class="infor_params_box">
            <p>
              <label for="">清单类型：</label><span class="infor_params_value">{{ beltMsg.inventory_type }}</span>
            </p>
            <p>
              <label for="">分厂/所属区域：</label><span class="infor_params_value">{{ beltMsg.gylx }}</span>
            </p>
            <p>
              <label for="">工序：</label><span class="infor_params_value">{{ beltMsg.technology_name }}</span>
            </p>
          </div>
        </div-->
        <div class="infor_params">
          <div class="title">
            <img src="./img/icon_gear_default.png" />
            <span>生产设备</span>
          </div>
          <div class="infor_params_box jiance_params_box" v-if="beltMsg.production && beltMsg.production.length > 0">
            <p>
              <label v-if="beltMsg.staticProductionName">{{ beltMsg.staticProductionName }}：</label>
              <span :style="item.name == '物料种类：' ? 'width:75%' : ''" v-for="(item, i) in beltMsg.production" v-bind:key="i">{{ item.name }}
                <span>{{ item.value }}</span>
              </span>
            </p>
          </div>
        </div>
        <div class="infor_params">
          <div class="title">
            <img src="./img/icon_gear_default.png" />
            <span>监测设备</span>
          </div>
          <div class="infor_params_box jiance_params_box" v-if="beltMsg.monitoring && beltMsg.monitoring.length > 0">
            <div v-for="(item, i) in beltMsg.monitoring" v-bind:key="i">
              <label v-if="item.deviceName">{{ item.deviceName }}：</label>
              <p>设备编码：<span>{{ item.deviceNo }}</span></p>
              <p>设备安装位置：<span>{{ item.deviceName }}</span></p>
              <template v-if="item.valueList && item.valueList.length > 0">
                <p v-for="(itemC, iC) in item.valueList" v-bind:key="iC">{{ itemC.name }}：<span>{{ itemC.value }}</span>
                </p>
              </template>
            </div>
          </div>
        </div>
        <div class="infor_params">
          <div class="title">
            <img src="./img/icon_gear_default.png" />
            <span>治理设备</span>
          </div>
          <div class="infor_params_box jiance_params_box" v-if="beltMsg.government && beltMsg.government.length > 0">
            <div v-for="(item, i) in beltMsg.government" v-bind:key="i">
              <label v-if="item.deviceName">{{ item.deviceName }}：</label>
              <p>设备编码：<span>{{ item.deviceNo }}</span></p>
              <template v-if="item.valueList && item.valueList.length > 0">
                <p v-for="(itemC, iC) in item.valueList" v-bind:key="iC">{{ itemC.name }}：<span>{{ itemC.value }}</span>
                </p>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div title="现场照片" v-if="beltMsg.img" style="width: 46%">
        <div class="title">
          <img src="./img/icon_gear_default.png" />
          <span>现场照片</span>
        </div>
        <div class="img_inner box" :style="{ height: imageHeight * 0.5 + 'px' }">
          <img :src="beltMsg.img" :style="{ height: imageHeight * 0.5 + 'px' }" />
        </div>
        <div class="img_p">现场高清图片</div>
        <div class="img_p"></div>
      </div>
      <div title="现场照片" v-else style="width: 46%">
        <div class="img_inner box" :style="{ height: imageHeight * 0.5 + 'px' }">
          <img src="./img/no_img.png" :style="{ height: imageHeight * 0.5 + 'px' }" />
        </div>
        <div class="img_p">图片待上传</div>
      </div>
    </div>
  </div>
</template>
<script>
import { unref } from "vue";
export default {
  data() {
    return {
      beltMsg: { productName: [], government: [], monitoring: [], img: "" }, //皮带
      //sinterMsg: { technologyName: "", parameters: [] },
      //shedMsg: { parameters: [], treatmentEquipment: [], img: [] }, //料棚
      //washMsg: null, //洗车机
      imageHeight: this.height ? this.height : 980,
    };
  },
  props: ["informationData", "height", "inventoryName"],
  watch: {
    informationData: {
      handler(newVal, oldVal) {
        this.beltMsg = newVal;
        this.CheckImgExists(this.beltMsg);
        this.$forceUpdate();
      },
      deep: true,
      /*console.log(val);
      this.paramsList.inventoryId = val;
      this.beltMsg = { productName: [], government: [], monitoring: [], img: "" };
      this.init();*/
    },
    height: {
      handler(newVal, oldVal) {
        this.imageHeight = newVal ? newVal : 980;
        this.$forceUpdate();
      },
      deep: true,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.beltMsg = this.informationData;
      this.CheckImgExists(this.beltMsg);
      this.$forceUpdate();
    },
    CheckImgExists(obj) {
      let that = this;
      if (obj && obj.img) {
        var ImgObj = new Image(); //判断图片是否存在
        /*if (ImgObj.complete) {
          if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
            //this.beltMsg.img = "http://wx.bmetech.com/screen/saver/nopicture.png";
          } else {
            that.beltMsg.img =
              "http://wx.bmetech.com/screen/saver/nopicture.png";
            that.$forceUpdate();
          }
        }*/
        ImgObj.onerror = function () {
          that.beltMsg.img = "http://wx.bmetech.com/screen/saver/nopicture.png";
          that.$forceUpdate();
        };
        ImgObj.onload = function () {
          if (ImgObj.fileSize > 0 || (ImgObj.width > 0 && ImgObj.height > 0)) {
            //this.beltMsg.img = "http://wx.bmetech.com/screen/saver/nopicture.png";
          } else {
            that.beltMsg.img =
              "http://wx.bmetech.com/screen/saver/nopicture.png";
            that.$forceUpdate();
          }
        };
        ImgObj.src = obj.img;
      } else {
        this.beltMsg.img = "http://wx.bmetech.com/screen/saver/nopicture.png";
        this.$forceUpdate();
      }

      //存在图片
    },
    /*async init() {
      //1：皮带信息，2：料棚，3：洗车机，4：密闭类（车间）
      //测试
      //		this.paramsList.inventoryId=1585381460160001;
      let res = null;
      if (this.customerId === 26) {
        res = await this.$get("/bzEmission/getBeltZongHeng", this.paramsList);
        this.beltMsg = res;
      } else {
        res = await API.inventory_getBelt(this.paramsList);
        this.beltMsg = res.data;
      }
    },
    getData() {},*/
  },
  components: {},
};
</script>
<!---203
-103-->
<style lang="scss" scoped="scoped">
.title {
  padding: 10px 0;
  img {
    vertical-align: middle;
  }
  span {
    color: #3fad92;
    font-size: 28px;
    vertical-align: middle;
  }
}
/*.information{*/
.infor_box {
  width: 100%;
  /*max-height: 1075px;*/
  display: flex;
  .infor_inner {
    width: 54%;
    .infor_params,
    .infor_zhili {
      position: relative;
      margin-bottom: 30px;
      .infor_params_title {
        font-size: 36px;
        &:before {
          content: "";
          width: 22px;
          height: 23px;
          background: rgba(61, 223, 226, 1);
          border-radius: 50%;
          position: absolute;
          top: 12px;
          left: -40px;
        }
      }
      .infor_params_box {
        color: #cadbe5;
        display: flex;
        flex-wrap: wrap;
        label{
          font-size: 20px;
          color: #cadbe5;
        }
        p {
          width: 40%;
          line-height: 40px;
          /*margin-bottom: 16px;*/
          display: flex;
          flex-wrap: wrap;
          font-size: 20px;
          color: #cadbe5;
          label {
            font-size: 20px;
          }
          span {
            display: inline-block;
            width: 44%;
            margin-right: 30px;
            /*margin-bottom: 16px;*/
            color: #3ddfe2;
            font-size: 18px;
            span {
              color: #cadbe5;
              font-size: 20px;
            }
          }
          .infor_params_value {
            color: #cadbe5;
            font-size: 20px;
          }
        }
      }
      .jiance_params_box {
        display: flex;
        flex-direction: column;
        p {
          width: 100%;
          label {
            width: 100%;
            display: block;
            margin-bottom: 16px;
          }
        }
      }
    }
    .infor_zhili {
      .infor_params_box {
        color: #cadbe5;
        display: block;
        p {
          width: 100%;
          display: flex;
          line-height: 40px;
          span {
            line-height: 70px;
            span {
              color: #3ddfe2;
            }
          }
        }
      }
    }
  }
  .img_inner {
    /*@include bg-box(100%, 400px, "img_iframe.png");*/
    padding: 4px;
    height: 70%;
    /*width: 40%;*/
    img {
      width: 100%;
      height: 100%;
      &:nth-of-type(1) {
        margin-bottom: 20px;
      }
    }
  }
  .img_p {
    line-height: 40px;
    text-align: center;
    font-size: 22px;
    font-family: "fontNormal";
  }
}

img {
  display: inline-block;
}
/*}*/
</style>
